import { Component, OnInit, NgModule, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';
import { Constant } from 'src/app/helpers/constants/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
import { AlertSwipeComponent } from 'src/app/common-shared-modules/alert-swipe/alert-swipe.component';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-group-renewal-landing , ngbd-accordion-basic',
  templateUrl: './group-renewal-landing.component.html',
  styleUrls: ['./group-renewal-landing.component.css']

})

export class GroupRenewalLandingComponent implements OnInit {

  productName: string;
  insuredMembers = [];
  policyDetails = [];
  getpolicyDetail = []; // to getpolicyDetail
  suminsured: number;
  initialsuminsured: number;
  policyNoArray: any;
  certificateNo: any;
  showAutoDebitModal: any;
  selectedPolicyDetails: any;
  heathReturnAmt: any;
  applyHealthReturn: any;
  refNoSelected: any;
  policySelected: any;
  todayDay: any;
  todayMonth: any;
  dd: any;
  mm: any;
  tenureVal: any;
  upSellSumInsured: number;
  autoDebitProcessDate: any;
  OmniEvents: any;
  Ewflag: boolean;
  isActive: boolean;
  form: FormGroup;
  updatedPremium: any;
  viewPopup: boolean;
  loading = false;
  submitted = false;
  showSumInsured = false;
  indexVal = 1;
  hideHeader = false;
  showSumInsure = false;
  updateMembers = 'N';
  updateHealthMiMembers = 'N';
  showHealthReturn = false;
  showThirdTenureVal = false;
  showSliderMenu = false;
  showSliderMenuMob = false;
  showPaymentModeModal = false;
  pgPaymentMode = 'emandate_normal';
  showModal = false;
  showPage = false;
  showSumInsuredValue = false;
  refNo = [];
  totalPreminum:any = 0;
  showHealthMiModal = true;
  HRAmount = 0;
  viewMember: boolean
  showDetail: boolean; // for show detail email and mobile number popup
  mobileNumber: any; // user updated mobile number
  emailAddress: any; //user updated email address
  downloadNotice = []; // download renewal notice
  fileName = "Group-Notice-"; // filename
  updateMember = {};
  usertoken: any; //ut value

  GHDform: FormGroup;
  RmarkTextBox: boolean[] = [];
  memberDataSourceList: any;
  ghdArray: any = [];
  memberArray: any = [];
  showGHDModal = false;
  showGHDBackModal = false;
  visibalSubmitButton: boolean = true;
  showHealthGHDModal = true;
  @ViewChild('errorModal')
  errorModal!: ModalDirective;
  showHideAutoDebitOption: boolean = false;
  declareM:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public appservice: LocalserviceService,
    public matDialog: MatDialog,
  ) {

  }
  // private alertSwipe =new AlertSwipeComponent()
  @ViewChild(AlertSwipeComponent) private alertSwipe:
    AlertSwipeComponent;
  messageObj: any;


  ngOnInit(): void {
    this.form = this.formBuilder.group({
      pgPaymentMode: ["emandate_normal", Validators.required],
      isActive: ['', Validators.required],
      emailAddress: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      Ideclear: [true, Validators.required],
    })
    //this.onStart();
    this.onStart();

    this.GHDform = this.formBuilder.group({
      GhdFormArray: this.formBuilder.array([]),
    });
   
    console.log(this.alertSwipe)
  }
  
  get GhdFormArray(): FormArray {
    return this.GHDform.get('GhdFormArray') as FormArray;
  }

  memberDetails() {
    this.GhdFormArray.push(this.formBuilder.group({
      Remarks: new FormControl(''),
      ghdApplicable: new FormControl(''),
    }))
  }

  onStart() {
    //var sessionStorageValue = JSON.parse(sessionStorage.refNoArray);
    if (sessionStorage.refNoArray == null || sessionStorage.refNoArray == 'undefined') {
      window.location.href = 'https://www.adityabirlacapital.com/healthinsurance/buy-insurance-online/#!/renewal-renew-policy';
      return false;
    } else {
      this.getAllPolicy();
    }
  }

  /*-----------------view member list------------------------*/
  viewMembers(event) {
    if (event == "custom-popover") {
      this.viewMember = true;
    } else {
      this.viewMember = false;
    }

    // event.target.parentElement.getElementsByClassName("custom-tooltip-text").css('display','inline');

  }

  /*----------------- view member list end ----------------- */


  /*----- To Get All Policy Details ------- */

  getAllPolicy() {
    this.policyNoArray = []
    this.certificateNo = [];
    this.Ewflag = true;

    var sessionStorageVal = JSON.parse(sessionStorage.refNoArray);
    for (var i = 0; i < sessionStorageVal.length; i++) {
      this.refNo.push(sessionStorageVal[i].ReferenceNo);
      this.certificateNo.push(sessionStorageVal[i].CertificateNumber);
    }

    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/GetAllGroupPolicies', { "ReferenceNo": this.refNo[0], "CertificateNumber": "" }, Constant.header).subscribe(res => {
      console.log(res);
      this.appservice.hide()
      if (res.ResponseCode == '1') {
        this.policyDetails = res.ResponseData;
        this.selectedPolicyDetails = this.policyDetails[0];
        //this.policySelected = this.policyDetails[0].Certificate_number;
        this.refNoSelected = this.policyDetails[0].ReferenceNo;
        this.productName = this.policyDetails[0].ProductName;
        this.tenureVal = this.policyDetails[0].Tenure;
        this.memberDataSourceList = this.selectedPolicyDetails.Members;
        if (this.memberDataSourceList[0].GHDApplicable == 'Y') {
          for (let i = 0; i < this.memberDataSourceList.length; i++) {
            this.memberDetails();
          }
          this.RmarkTextBox.push(false);
          this.showGHDModal = true;
        }

        if (this.policyDetails[0].Combi_Flag == 'Y') {
          if(this.policyDetails.length > 1) {
            this.showHideAutoDebitOption = true;
          }
          for (var i = 0; i < this.policyDetails.length; i++) {
            if (this.policyDetails[i].Certificate_number.startsWith('GHI')) {
              this.policySelected = this.policyDetails[i].Certificate_number;
            }
          }
        } else {
          this.showHideAutoDebitOption = false;
          this.policySelected = this.policyDetails[0].Certificate_number;
        }
        if (this.policyDetails[0].HealthReturnFlag == 'Y') {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
        
        for (var i = 0; i < this.policyDetails.length; i++) {
          this.totalPreminum += parseFloat(this.policyDetails[i].UpdatedGrossPremium);
          this.totalPreminum = Math.round(this.totalPreminum*100)/100; 
          if (this.policyDetails[i].EWFlag == "Y") {
            this.Ewflag = false;
            for (var j = 0; j < this.policyDetails[i].Members.length; j++) {
              //this.HRAmount = 0;
              this.HRAmount += parseFloat(this.policyDetails[i].Members[j].HR_Amount);
              //this.insuredMembers = this.policyDetails[i].Members;
            }
            //this.HRAmount = this.HRAmount + HRVal;
          } if ((this.policyDetails[i].Email == "" || this.policyDetails[i].Email == null || this.policyDetails[i].Email == undefined || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.policyDetails[i].Email))) || (this.policyDetails[i].Mobile == "" || this.policyDetails[i].Mobile == null || this.policyDetails[i].Mobile == undefined || !(/^[6789]\d{9}$/.test(this.policyDetails[i].Mobile)))) {
            this.showDetail = false;
          } else {
            this.showDetail = true;
          }
        }

        // $window.gtag('config', ' UA-87053058-1', {
        //   'page_path': window.location.pathname + window.location.hash,
        //   'title': $rootScope.pageTitle,
        //   'dimension7': this.policySelected,
        //   'dimension1': document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".")
        // });
        this.insuredMembers = this.policyDetails[0];
        //this.initializeupdateMember();

        // this.suminuredValue(this.insuredMembers, this.selectedPolicyDetails);
        // healthReturnValue(this.insuredMembers);
        if (this.productName == 'Active Care V2' || this.productName == 'Activ Care') {
          this.showThirdTenureVal = true;
        } if (this.policyDetails[0].UpsellFlag == 'Y' && this.insuredMembers[0].UpSellSumInsured != 0) {
          this.showSumInsured = true
          this.indexVal = 1;
          this.upSellSumInsured = this.insuredMembers[0].UpSellSumInsured;
          if (this.suminsured == this.upSellSumInsured) {
            this.updateMembers = 'Y';
          }
          var UpsellMembersCount = 0;
          this.insuredMembers.forEach(function (item, index) {
            if (item.SumInsured == item.UpSellSumInsured) {
              this.updateMember[item.RelationWithProposer] = 'Y';
              UpsellMembersCount++;
            }
          })
          if (this.insuredMembers.length == UpsellMembersCount) {
            this.updateHealthMiMembers = 'Y';
          }

        } else {
          this.showSumInsured = false;
          this.indexVal = 0
        }
        var policySelected0 = true;

        // this.fetchHealthReturnStatus()

        if (window.innerWidth > 650) {
          this.showSliderMenu = false;
          //$scope.instantiateSlider();
        }
      } else if (res.ResponseCode == 0) {
        var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "210px";
        alertModel.width = "480px";
        alertModel.data = {
          title: "Alert Model",
          description: errorMessage,
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }
    });

  }

  /*----- End of To Get All Policy Details ------- */

  /* -------------------enter mobile number email address popup--------------------- */

  updateUserDetail() {
    if (this.mobileNumber == "" || this.mobileNumber == undefined) {
      this.messageObj = {
        "messageVal": "Please enter mobile number",
        "classVal": "e",
        "showAlertSwipe": true
      }

      this.alertSwipe.sliderAlertSwipe(this.messageObj);
      return false;
    } if (this.emailAddress == "" || this.emailAddress == undefined) {
      this.messageObj = {
        "messageVal": "Please enter email Address",
        "classVal": "e",
        "showAlertSwipe": true
      }
      this.alertSwipe.sliderAlertSwipe(this.messageObj);
      return false;
    } if (!(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.emailAddress))) {
      this.messageObj = {
        "messageVal": "Please enter valid email Address",
        "classVal": "e",
        "showAlertSwipe": true
      }
      this.alertSwipe.sliderAlertSwipe(this.messageObj);
      return false;
    } if (!(/^[6789]\d{9}$/.test(this.mobileNumber))) {
      this.messageObj = {
        "messageVal": "Please enter valid mobile number",
        "classVal": "e",
        "showAlertSwipe": true
      }

      this.alertSwipe.sliderAlertSwipe(this.messageObj);
      return false;
    }

    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/UpdateContactDetails', { "ReferenceNo": this.refNo[0], "Proposer_MobileNo": this.mobileNumber, "Proposer_Email": this.emailAddress }, Constant.header).subscribe(res => {
      console.log(res)
      this.appservice.hide()
      if (res.ResponseCode == 1) {
        var successmsg = res.ResponseMessage;
        this.messageObj = {
          "messageVal": successmsg,
          "classVal": "e",
          "showAlertSwipe": true
        }
        this.alertSwipe.sliderAlertSwipe(this.messageObj);
        this.showDetail = true;
        this.selectPaymentMode();
      } else {
        if (res.ResponseCode == 0) {
          var errorMessage = res.ResponseData != null ? res.ResponseMessage : res.ResponseData.ErrorMessage
          const alertModel = new MatDialogConfig();
          alertModel.disableClose = true;
          alertModel.id = "modal-component";
          alertModel.height = "210px";
          alertModel.width = "480px";
          alertModel.data = {
            title: "Alert Model",
            description: errorMessage,
            successText: "OK",
            failureText: "cancel",
            showSuccessBtn: true,
            showFaliureBtn: true,

          }
          const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
        }
      }
    })
  }

  /*  -------------------enter mobile number email address popup--------------------- */

  /*------------------------------download renewal notice-------------------------- */

  DownloadRenewalNotice() {
    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/DownloadNotice', { "ReferenceNo": this.refNo[0], "COINumber": this.policySelected }, Constant.header).subscribe(res => {
      console.log(res)
      this.appservice.hide()
      if (res.ResponseCode == 1) {
        this.downloadNotice = res.ResponseData.groupSearchDownloads;
        for (var i = 0; i <= this.downloadNotice.length; i++) {
          var ByteArray = this.downloadNotice[i].ByteArray;
          this.fileName = this.fileName + this.downloadNotice[i].CertificateNumber;
          const source = `data:application/pdf;base64,${ByteArray}`;
          const link = document.createElement("a");
          link.href = source;
          link.download = `${this.fileName}.pdf`
          link.click();
          this.fileName = null;
          this.fileName = "Group-Notice-"
        }
      } else {
        var errorMessage = res.ResponseData == null ? res.ResponseMessage : res.ResponseData.ErrorMessage
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "210px";
        alertModel.width = "480px";
        alertModel.data = {
          title: "Alert Model",
          description: errorMessage,
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }
    })
  }

  /*---------------------start of ewflag-------------------------- */
  updateSumInsured(param) {
    console.log(param);
    var policySelected
    if (param) {
      policySelected = "Y";
    } else {
      policySelected = "N";
    }

    this.appservice.show();
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/updateHealthReturn', { "ReferenceNo": this.refNo[0], "healthreturnflag": policySelected }, Constant.header).subscribe(res => {
      this.appservice.hide();
      console.log(res)
      if (res.ResponseCode == 1) {
        this.updatedPremium = res.ResponseData;
        this.totalPreminum = 0;
        this.updatedPremium.forEach(e => {
          this.totalPreminum += parseFloat(e.UpdatedPremium);
          this.totalPreminum = Math.round(this.totalPreminum*100)/100;
        });
      } else if (res.ResponseCode == 0) {
        var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "210px";
        alertModel.width = "480px";
        alertModel.data = {
          title: "Alert Model",
          description: errorMessage,
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }
    })
  }
  /*---------------------end of ewflag-------------------------- */

  /*-------------------- To Select Payment Mode --------------------------*/
  selectPaymentMode() {
    if (!this.showDetail) {
      this.updateUserDetail()
    } else {
      if (this.selectedPolicyDetails.Autodebit === 'N' && this.policyDetails[0].Combi_Flag === 'Y' && this.policyDetails.length > 1) {
        this.showPaymentModeModal = true;this.form.get('pgPaymentMode')?.setValue('JP_normal');
      } else if (this.selectedPolicyDetails.Autodebit === 'N') {
        this.showPaymentModeModal = true;
        this.form.get('pgPaymentMode')?.setValue('emandate_normal');
      } else if (this.selectedPolicyDetails.Autodebit == 'Y') {
        var today = new Date();
        this.todayMonth = today.getMonth() + 1;
        if (this.todayMonth < 10) {
          this.todayMonth = "0" + (today.getMonth() + 1);
        }
        this.todayDay = today.getDate();
        if (this.todayDay < 10) {
          this.todayDay = "0" + today.getDate();
        }
        var TodayDate = today.getFullYear() + "" + this.todayMonth + "" + this.todayDay;

        var expDate = this.selectedPolicyDetails.PolicyExpiryDate.trim().split('/');
        var PolicyExpDate = expDate[1] + "/" + expDate[0] + "/" + expDate[2];
        var PolicyExpDate1 = expDate[2] + "" + expDate[1] + "" + expDate[0];

        var autoDebitProcessDate = new Date(PolicyExpDate);
        autoDebitProcessDate.setDate(autoDebitProcessDate.getDate() - 15);
        var dd = autoDebitProcessDate.getDate();
        var mm = autoDebitProcessDate.getMonth() + 1;
        var yyyy = autoDebitProcessDate.getFullYear();
        if (this.dd < 10) {
          this.dd = '0' + dd
        }
        if (this.mm < 10) {
          this.mm = '0' + mm
        }
        this.autoDebitProcessDate = yyyy + "" + mm + "" + dd;

        if ((TodayDate >= this.autoDebitProcessDate) && (TodayDate <= PolicyExpDate1)) {
          this.showAutoDebitModal = true;
        } else {
          this.pgPaymentMode = 'JP_normal';
          // requestPgURL();
        }

      }
    }

  }

  /*-------------------- To Select Payment Mode Ends--------------------------*/
  requestPgURL() {
    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/PGRequest', { "ReferenceNo": this.refNo[0], "PaymentType": this.form.get('pgPaymentMode').value }, Constant.header).subscribe(res => {
      if(res.ResponseCode === 1) {
        this.appservice.hide()
        const url = res.ResponseData
        sessionStorage.setItem('url', url);
        window.location.href = `${'/healthinsurance/AbhiGroupRenewal/payment-gateway'}`;
      } else {
        this.appservice.hide();
        this.errorModal.show();
      }
        
      }
  )

  }

  /*------------ Intialization Scope UpdateMember -------------*/

  initializeupdateMember() {
    this.insuredMembers.forEach((item, index) => {
      this.updateMember[item.RelationWithProposer] = 'N';
      //console.log(this.updateMember);
    })
    console.log(this.updateMember);
  }

  /*------------ End of Intialization Scope UpdateMember -------------*/


  /*------ To Get Total Heath Return Amount Of all Members --------- */

  healthReturnValue(insuredMembers) {
    var heathReturnSum = 0;
    for (var i = 0; i < insuredMembers.length; i++) {
      if (insuredMembers[i].HealthReturn > 0) {
        heathReturnSum = heathReturnSum + parseFloat(insuredMembers[i].HealthReturn);
      }
    }
    if (heathReturnSum > 0) {
      this.heathReturnAmt = heathReturnSum.toFixed(2);
      this.showHealthReturn = true;
    }
  }

  /*------ End of To Get Total Heath Return Amount Of all Members --------- */


  /*--------- To Open Modal --------*/

  openModal() {
    this.showModal = true;
  }

  /*--------- End of To Open Modal ----------------*/

  /*--------- To Close Modal --------------*/

  closeModal() {
    this.showModal = false;
  }

  /*--------- End of To Close Modal -------------*/


  gHDmemberEvent(event, index: number) {
    let checkvalue = event.target.value;
    // this.ghdCountValue += 1;
    if (checkvalue == 'Y') {
      this.RmarkTextBox[index] = true;
      this.GhdFormArray.at(index).get('ghdApplicable').setValue(checkvalue);
    } else {
      this.RmarkTextBox[index] = false;
      this.GhdFormArray.at(index).get('ghdApplicable').setValue(checkvalue);
    }
    if (this.GhdFormArray.at(index).get('ghdApplicable').value !== '') {
      const copyIndex = index + 1;
      if (copyIndex == this.memberDataSourceList.length) {
        this.visibalSubmitButton = false;
      }
    } else {
      this.visibalSubmitButton = true;
    }
  }


  hideGHDModal() {
    if (this.GhdFormArray.value.length == this.memberDataSourceList.length) {
      const even = (test) => test.ghdApplicable === 'Y';
      let GhdValue = this.GhdFormArray.value.some(even);
      // console.log('GGGgg',GhdValue);
        if (GhdValue === true) {
          this.showGHDBackModal = true;
          this.showGHDModal = false;
        } else {
          this.getGHD();
        }
    } else {
      console.log('test Fill the all Remarks');
    }

  }

  getGHD() {
    const url = `/api/groupRenew/GHD`;
    const options = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'x-ob-bypass': Constant.x_ob_bypass,
    }

    for (let i = 0; i < this.memberDataSourceList.length; i++) {
      this.memberArray.push({
        "Member_Code": this.memberDataSourceList[i].Member_Code,
        "GHDApplicable": this.GhdFormArray.at(i).get('ghdApplicable').value,
        "GHDRemarks": this.GhdFormArray.at(i).get('Remarks').value
      })
      const ObjMember = {
        "ReferenceNo": this.policyDetails[0].ReferenceNo,
        "MasterPolicyNumber": this.policyDetails[0].Renewed_Masterpolicy_Number,
        "Certificate_number": "",
        "Memberdata": this.memberArray,
      };
      this.ghdArray.push(ObjMember);
    }
    const mObj = {
      "policyData": this.ghdArray
    }
    this.appservice.show();
    console.log(url, this.ghdArray, mObj);
    this.appservice.PostApi(Constant.hpre_BaseUrl + url, mObj, options).subscribe(res => {
      console.log(url, res);
      this.appservice.hide();
      if (res.ResponseCode == 1) {
        this.showGHDModal = false;
      }
    }, err => {
      this.appservice.hide();
    })
  }


  hideBackModal() {
    this.showGHDBackModal = false;
    // this.router.navigateByUrl('/renewal-group'); ---for local run
    window.location.href="https://www.adityabirlacapital.com/healthinsurance/buy-insurance-online/v2/renewal-renew-policy";
  }

}
